<clr-datagrid [clrDgLoading]="loading">
    <clr-dg-column [clrDgField]="'job_id'" [clrDgSortOrder]="descSort">Jobnummer</clr-dg-column>
    <clr-dg-column [clrDgField]="'job_date'">Auftragsdatum</clr-dg-column>
    <clr-dg-column [clrDgField]="'delivery_date'">Lieferdatum</clr-dg-column>
    <clr-dg-column [clrDgField]="'order_id'">Bestellnummer des Kunden</clr-dg-column>
    <clr-dg-column [clrDgField]="'name_project'">Projektname</clr-dg-column>
    <clr-dg-column class="currency">VK netto</clr-dg-column>
    <clr-dg-column [clrDgField]="'status'">Status</clr-dg-column>
    <clr-dg-placeholder>We couldn't find any Job!</clr-dg-placeholder>
    <clr-dg-row *clrDgItems="let job of jobs" [routerLink]="['/job/details/', job.project_id, job.job_id]">
        <clr-dg-cell>{{ job.project_id }}.0006.{{ job.job_id }}</clr-dg-cell>
        <clr-dg-cell>{{ job.job_date | date: "dd.MM.yyyy" }}</clr-dg-cell>
        <clr-dg-cell><span *ngIf="job.delivery_date !== '0000-00-00'">{{ job.delivery_date | date: "dd.MM.yyyy" }}</span></clr-dg-cell>
        <clr-dg-cell>{{ job.order_id }}</clr-dg-cell>
        <clr-dg-cell><b>{{ job.name_project }}</b></clr-dg-cell>
        <clr-dg-cell class="currency"><b>{{ job.budget | currency: 'EUR':'code':'1.2-2':'de'   }}</b></clr-dg-cell>
        <clr-dg-cell [className]="findButtonClass(job.status)" role="alert">
            <div class="alert-items">
                <div class="alert-item static">
                    <span class="alert-text">{{ getCellStatus(job.status).statusDisplay}}</span>
                </div>
            </div>
        </clr-dg-cell>
    </clr-dg-row>
    <clr-dg-footer>
        <clr-dg-pagination #pagination [clrDgPageSize]="50">
            <clr-dg-page-size [clrPageSizeOptions]="[10,25,50,100]">Jobs pro Seite</clr-dg-page-size>
            {{pagination.firstItem + 1}} - {{pagination.lastItem + 1}}
            von {{jobs.length}} Job(s)
        </clr-dg-pagination>
    </clr-dg-footer>
</clr-datagrid>

